// Dependencies
import React from 'react';
import request from 'superagent';
import { Link } from 'react-router-dom';

import * as InstrumentUtils from 'utils/instrument';
import * as FormUtils from 'utils/form';
import * as Trade from 'utils/trade';
import { EXCHANGE_URL, COMPONENTS_URL } from 'constants/Jaws';
import {
  getSelectedAccount,
  getAvailableVolume,
  getCustomerNumber,
} from 'utils/customer';
import { safeguardCheck } from 'utils/trade';
import { getUserId, getCustomerData } from 'utils/user';

/**
 * Holds methods that all trade components have in common.
 * Extend to recieve trade frament functionality.
 */
export default class TradeComponent extends React.Component {
  state = {};

  loadFromItemSector(itemSector) {
    return InstrumentUtils.getByItemSector(itemSector).then(res => {
      const instrument = {
        ITEM: res.get('item'),
        SECTOR: res.get('sector'),
        LONG_NAME: res.get('LONG_NAME'),
      };

      // Set the instrument initial value in an ugly but functional way
      if (this.Instrument && this.Instrument.current) {
        this.Instrument.current.value = instrument.ITEM;
      }

      this.props.fields.instrument.onChange(instrument);
      this.getLast(instrument);
      this.fetchPeakSize(instrument);
      this.fetchTickAndLotSizes(instrument);
    });
  }

  reportInvalidFormIfInvalid(title) {}

  fetchTickAndLotSizes({ ITEM, SECTOR }) {
    // Get TICK_SIZE and revalidate
    request
      .get(
        `${EXCHANGE_URL}/${SECTOR.toUpperCase()}/ticker/` +
          `${ITEM.toUpperCase()}/limit-rules`,
      )
      .end((err, res) => {
        if (err) {
          throw new Error(
            'TradeComponent.fetchTickAndLotSizes ' +
              'GET tickSize failed: ' +
              err,
          );
        }

        this.props.fields.tickSizeRules.onChange(res.body.data);
      });

    // Get LOT_SIZE and revalidate
    request
      .get(
        `${EXCHANGE_URL}/${SECTOR.toUpperCase()}/ticker/` +
          `${ITEM.toUpperCase()}/lot-size`,
      )
      .end((err, res) => {
        if (err) {
          throw new Error(
            'TradeComponent.fetchTickAndLotSizes ' +
              'GET lotSize failed: ' +
              err,
          );
        }

        this.props.fields.lotSizeRule.onChange(res.body.data);
      });
  }

  /**
   * The peak size is the current EXCHANGE_MARKET_SIZE of the itemSector.
   * This is used for validation, as the visible volume must be > this
   * value.
   */
  fetchPeakSize({ ITEM, SECTOR }) {
    request
      .get(COMPONENTS_URL)
      .query({
        columns: 'EXCHANGE_MARKET_SIZE',
        itemSector: `${ITEM}.${SECTOR}`,
      })
      .end((err, res) => {
        if (err) throw new Error(err);

        const peakSize =
          (res.body.rows[0] && res.body.rows[0].values.EXCHANGE_MARKET_SIZE) ||
          0;
        this.props.fields.peakSize.onChange(peakSize);
      });
  }

  fetchVolume() {
    const { user, fields } = this.props;
    const { ITEM, SECTOR } = fields.instrument.value;
    const userId = getUserId(user);
    const customerId =
      this.props.location.query.accountId ||
      getSelectedAccount(getCustomerData(user)).get('customerId');

    this.getUserVolume(userId, customerId, SECTOR, ITEM);
  }

  getUserVolume(userId, accountId, sector, item) {
    if (process.env.NODE_ENV === 'test') return;
    getAvailableVolume(userId, accountId, item, sector).end((err, res) => {
      if (err) {
        throw new Error('getUserVolume: failed to fetch volume: ' + err);
      }

      this.props.fields.availableVolume.onChange(res.body.data.availableVolume);
    });
  }

  getLast({ ITEM, SECTOR }) {
    request
      .get(COMPONENTS_URL)
      .query({
        itemSector: `${ITEM}.${SECTOR}`,
        columns: 'ITEM,LASTNZ_DIV',
      })
      .end((err, res) => {
        if (err) throw new Error(err);

        this.props.fields.last.onChange(
          res.body.rows[0] && res.body.rows[0].values.LASTNZ_DIV,
        );
      });
  }

  /**
   * Get information about an inserted order to show in modal
   */
  getOrderDetails(orderId) {
    const { user } = this.props;
    const customerId = getSelectedAccount(getCustomerData(user)).get(
      'customerId',
    );

    Trade.getDetails(
      getCustomerNumber(user),
      customerId,
      orderId,
      (err, res) => {
        if (err) throw new Error(err);

        const completeOrder = Object.assign(
          {},
          this.state.completeOrder,
          res.body.data,
        );
        this.setState({ completeOrder });
      },
    );
  }

  checkFatFinger(e) {
    const { last, limit } = this.props.fields;

    this.setState({ warnings: null });

    const normalizedLimit = FormUtils.normalizeNumber(e.target.value);
    const passSafeguardCheck =
      !last.value || safeguardCheck(normalizedLimit, last.value);

    // Show the warning only after the field has been touched
    if (!passSafeguardCheck && (e.type === 'blur' || limit.touched)) {
      const warning = 'Limit avviker mer enn 30% fra sist omsatte kurs';

      this.setState({ warnings: [warning] });
    }

    // Trigger the redux-form event like normal
    if (e.type === 'blur') {
      limit.onBlur(e);
    } else {
      limit.onChange(e);
    }
  }

  /** Needed to handle %LINK_MAN_TRANS% workaround */
  printError(errorString, instrument) {
    if (!errorString.includes('%LINK_MAN_TRANS%')) {
      return errorString;
    }

    const { ITEM, SECTOR } = instrument;

    // Replace %LINK_MAN_TRANS% with a <Link> to the manual transaction page
    return (
      <p>
        {errorString.replace('%LINK_MAN_TRANS%', '')}&nbsp;
        <Link to={`/transactions/new/${ITEM}.${SECTOR}`}>
          en manuell transaksjon.
        </Link>
      </p>
    );
  }
}
